import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement, toggleVisibility } from 'utils/toggle_element_visibility'

export default class extends Controller {
  initialize() {
    this.table = this.element
  }

  // Roughly based on https://github.com/tofsjonas/sortable/blob/main/sortable.js
  sort(event) {
    const clickedElement = event.target
    const th = clickedElement.nodeName === "TH" ? clickedElement : clickedElement.closest("th")

    const tr = th.parentNode

    const allTh = tr.cells
    const columnIndex = Array.from(allTh).indexOf(th)

    const currentlySorted = !!th.dataset.sorted
    th.dataset.sorted = true

    let reverse = false
    if (currentlySorted) {
      reverse = th.classList.toggle("-reverse")
    } else {
      th.classList.remove("-reverse")
    }

    this._sortRows(columnIndex, reverse)

    this._updateSortIcon(th)
  }

  _sortRows(columnIndex, reverse) {
    // Extract all table rows
    const tBody = this.table.tBodies[0]
    const tRows = Array.from(tBody.rows)

    const sortedRows = [...tRows].sort((a, b) => {
      const cellA = a.children[columnIndex]
      const cellB = b.children[columnIndex]
      const textA = cellA.getAttribute("data-sort-value") || cellA.innerText
      const textB = cellB.getAttribute("data-sort-value") || cellB.innerText

      return this._sortTextOrNumber(textA, textB, reverse)

    })

    // Make a clone without content
    const clonedTbody = tBody.cloneNode()

    // Build a sorted table body
    sortedRows.forEach((row) => clonedTbody.appendChild(row))

    // And finally insert the end result
    this.table.replaceChild(clonedTbody, tBody)
  }

  // https://stackoverflow.com/a/49657998/1202488
  _sortTextOrNumber(textA, textB, reverse) {
    let compareValueA, compareValueB
    // if we're comparing number to number, do number sorting
    if(!isNaN(textA) && !isNaN(textB)) {
      compareValueA = parseInt(textA)
      compareValueB = parseInt(textB)
    } else {
      compareValueA = textA
      compareValueB = textB
    }

    // else sort as strings
    if (compareValueA < compareValueB) {
      return reverse ? 1 : -1
    } else if(compareValueA > compareValueB) {
      return reverse ? -1 : 1
    } else {
      return 0
    }
  }


  _updateSortIcon(th) {
    // Hide existing icon
    this.table.querySelectorAll(".c-table-cell_sort-icon").forEach(hideElement)
    this.table.querySelectorAll(".-sorted").forEach(el => el.classList.remove("-sorted"))

    // Show correct icon
    const icon = th.querySelector(".c-table-cell_sort-icon")
    showElement(icon)
    th.classList.add("-sorted")
  }
}
